import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'Packages/FacetDesign/Components/Alert';
import { dataAttrs } from 'Helpers/Testing';
import { useMaybeMetaLayoutContext } from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const ErrorList2 = ({
  title,
  errors,
}) => {
  const { resource } = useMaybeMetaLayoutContext() ?? {};

  let details;
  let description;
  let titleText;
  if (errors.length === 1) {
    titleText = title || 'Error occurred';
    if (errors[0].detail) {
      description = errors[0].detail;
    }
  }
  if (errors.length > 1) {
    const detailsUnfiltered = errors.map((e) => e.detail);
    details = detailsUnfiltered.filter((d => d));
    titleText = title || 'Errors occurred';
  }

  return errors.length ? <Alert
    status={'error'}
    title={titleText}
    details={details}
    description={description}
    {...dataAttrs('error-list', resource)}
  /> : null;
};

ErrorList2.defaultProps = {
  errors: [],
  title: '',
};

ErrorList2.propTypes = {
  title: PropTypes.string,
  errors: PropTypes.array,
};

export { ErrorList2 };
